'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _upload = require('antd/lib/upload');

var _upload2 = _interopRequireDefault(_upload);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/upload/style');

require('antd/lib/button/style');

require('antd/lib/icon/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import styles from './style.css';

// const beforeUpload = (file) => {
//   const isLt10M = file.size / 1024 / 1024 < 10;
//   if (!isLt10M) {
//     message.error('Зурагны хэмжээ 10MB ээс бага байх ёстой');
//   }
//   return isLt10M;
// };


var ImageWidget = function (_React$Component) {
  _inherits(ImageWidget, _React$Component);

  function ImageWidget(props) {
    _classCallCheck(this, ImageWidget);

    var _this = _possibleConstructorReturn(this, (ImageWidget.__proto__ || Object.getPrototypeOf(ImageWidget)).call(this, props));

    _this.handleChange = function (info) {
      console.log('ImageWidget: ', info);
      if (info.file.status === 'done') {
        console.log('sss', info);
        _this.props.onChange(info.file.response.data);
      }
    };

    _this.state = {
      fileList: []
    };
    return _this;
  }

  _createClass(ImageWidget, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = {
        action: '//jsonplaceholder.typicode.com/posts/',
        multiple: true,
        onRemove: function onRemove(file) {
          _this2.setState(function (_ref) {
            var fileList = _ref.fileList;

            var index = fileList.indexOf(file);
            var newFileList = fileList.slice();
            newFileList.splice(index, 1);
            return {
              fileList: newFileList
            };
          });
        },
        beforeUpload: function beforeUpload(file) {
          console.log('beforeUpload: ', file);
          _this2.setState(function (_ref2) {
            var fileList = _ref2.fileList;
            return {
              fileList: [].concat(_toConsumableArray(fileList), [file])
            };
          });
          return false;
        },
        fileList: this.state.fileList
      };

      // /rest/store_product/upload_image
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _upload2.default,
          options,
          _react2.default.createElement(
            _button2.default,
            null,
            _react2.default.createElement(_icon2.default, { type: 'upload' }),
            ' Select File'
          )
        )
      );
    }
  }]);

  return ImageWidget;
}(_react2.default.Component);

ImageWidget.defaultProps = {
  // value: '',
};

ImageWidget.propTypes = {
  // value: PropTypes.string,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = ImageWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/ImageWidget/index.js
// module id = 1025
// module chunks = 0